<template>
  <WaggonInfoBody
    :color="workpackage.color"
    :work_package="workpackage"
    :info_box="wallet || $vuetify.breakpoint.smAndDown?false:true"
    :wallet="wallet"
    >
    <template #body-content>
      <StandardFlexBox
        height="34px"
        line_height="30px"
      >
      <div :style="`color:${workpackage.textcolor}`">{{$t('Project.Workpackage.Messages.Header')}} ({{getMessagesTWorkPackage(tworkpackage_id).length}})</div>

      </StandardFlexBox>
      <StandardMessage
        :readonly="false"
        :context_users="getProjectMembersForMessage(project_id)"
        :current_user="getUser"
        :project="getProject(project_id)"
        :twork_package="workpackage"
        @sendMessage="sendMessage($event)"
        ref="twpMsg"
      />
        <StandardFlexBox
          height="calc(100% - 44px)"
          id="logList"
          direction="column"
          :no_wrap="true"
          >
          <!-- :icon="getLogListIcon(msg)" -->
          <StandardDataField
            class="pa-1 mb-1"
            v-for="msg in JSON.parse(JSON.stringify(getMessagesTWorkPackage(tworkpackage_id))).reverse()"
            :key="msg.id"
            :header="`${msg.created.substring(0, 19)}`"
            :value="msg.text"
            :icon="getMessageIcon(msg)"
            :readonly="true"
            width="100%"

            />
        </StandardFlexBox>
    </template>
  </WaggonInfoBody>
</template>
<script>
import store from '@/store/index'
import StandardMessage from '@/components/StandardComponents/StandardMessage.component.vue'

import { WaggonInfoMixin } from '@/mixins/WaggonInfo.mixin.js'
import { mapGetters, mapActions } from 'vuex';
export default {
  props: ['project_id', 'train_id', 'taktarea_id', 'twaggon_id', 'tworkpackage_id', 'workpackage', 'wallet'],
  mixins: [
    WaggonInfoMixin
  ],
  components: { StandardMessage },
  beforeRouteEnter(to, from, next) {
    Promise.all([
      store.dispatch('ProjectMember/requestProjectMembers', {
        project_id: to.params.project_id
      }),
      store.dispatch('Message/requestMessagesTWorkPackage', {
        twork_package_id: to.params.tworkpackage_id
      })
    ])
    .then(() => {
      next();
    });
  },
  computed: {
    ...mapGetters('Message', [
      'getMessagesTWorkPackage'
    ]),
    ...mapGetters('Project', [
      'getProject'
    ]),
    ...mapGetters('ProjectMember', [
      'getProjectMembersForMessage',
    ]),
    ...mapGetters('TWorkPackage', [
      'getTWorkPackage'
    ]),
    ...mapGetters('Auth', [
      'getUser'
    ])
  },
  methods: {
    ...mapActions('Message', [
      'requestSendMessage'
    ]),
    sendMessage(msg){
      let add_twp = true;
      for (var i = 0; i < msg.twork_packages.length; i++) {
        if (msg.twork_packages[i].id === this.tworkpackage_id) {
          add_twp = false;
          break;
        }
      }
      if (add_twp) {
        msg.twork_packages.push({ id: this.tworkpackage_id});
      }
      this.requestSendMessage(msg);
      this.$refs.twpMsg.clearMessageText();
    },
    getMessageIcon(msg){
      if (msg.type === 'warning') {
        return 'warning';
      } else {
        return 'notifications';
      }
    }
  }
}
</script>
<style>
  div {
    user-select: none;
  }
  .no-scroll-y {
    overflow-y: hidden !important;
  }
</style>
